import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import {
  getVisitProduct,
  getOrderItemsList,
  setConsultationTypeOrderItemAddon,
  removeConsultationTypeOrderItemAddon,
  getOriginalRefillOrderItems,
} from "~/visits/utils/visitCookies";

import { productName } from "~/visits/components/payment/paymentHelpers";

import { ProductImage } from "~/visits/components/payment/paymentComponents";

import { kickBlue } from "~/shared/styles/baseStyles";

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(1),
  },
}));

export default function ChooseRefillOrderItems({ match }) {
  const classes = useStyles();
  const visitProduct = getVisitProduct();
  const orderItems = getOrderItemsList();
  const consultationType = match.params.consultationType;
  const originalRefillOrderItems = getOriginalRefillOrderItems();
  const [selectedOrderItems, setSelectedOrderItems] = useState(
    orderItems.map((oi) => oi.productSlug)
  );
  const mainOrderItem = originalRefillOrderItems.find(
    (oi) => oi.productSlug === visitProduct
  );
  const addons = originalRefillOrderItems.filter(
    (oi) => oi.productSlug !== visitProduct
  );

  return (
    <main className={classes.content} style={{ backgroundColor: "#eee" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "0 10px",
        }}
      >
        <h3 style={{ textAlign: "center", marginBottom: "20px" }}>
          Your Kick Refill
        </h3>

        <div
          style={{
            marginBottom: "20px",
            backgroundColor: "white",
            border: "1px solid #ddd",
            borderRadius: "6px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ width: "60px" }}>
              <ProductImage
                classes={classes}
                consultationType={mainOrderItem.consultationType}
                productType={mainOrderItem.productSlug}
                subcategory={mainOrderItem.subcategory}
                imgStyle={{
                  height: "100px",
                  width: "100px",
                  objectFit: "scale-down",
                  paddingRight: "5px",
                }}
              />
            </div>
            <div
              style={{
                marginLeft: "20px",
                fontSize: "18px",
                lineHeight: "1.5",
                padding: "0 18px",
              }}
            >
              {productName(
                mainOrderItem.productSlug,
                mainOrderItem.subcategory
              )}
            </div>
          </div>
        </div>

        <h4
          style={{
            textAlign: "center",
            marginBottom: "20px",
            marginTop: "20px",
          }}
        >
          Also refill these products?
        </h4>
        <div
          style={{
            padding: "20px",
            border: "1px solid #ddd",
            borderRadius: "6px",
            backgroundColor: "white",
          }}
        >
          {addons.map((orderItem) => (
            <div key={orderItem.productSlug}>
              <div style={{ display: "flex", alignItems: "center" }}>
                {orderItem.productSlug !== visitProduct && (
                  <Checkbox
                    style={{ color: kickBlue }}
                    checked={selectedOrderItems.includes(orderItem.productSlug)}
                    onChange={() => {
                      if (selectedOrderItems.includes(orderItem.productSlug)) {
                        setSelectedOrderItems(
                          selectedOrderItems.filter(
                            (slug) => slug !== orderItem.productSlug
                          )
                        );
                        removeConsultationTypeOrderItemAddon(
                          orderItem.consultationType,
                          orderItem.productSlug
                        );
                      } else {
                        setSelectedOrderItems([
                          ...selectedOrderItems,
                          orderItem.productSlug,
                        ]);
                        setConsultationTypeOrderItemAddon(
                          orderItem.consultationType,
                          orderItem.productSlug,
                          orderItem.subcategory
                        );
                      }
                    }}
                  />
                )}
                <div style={{ width: "60px" }}>
                  <ProductImage
                    classes={classes}
                    consultationType={orderItem.consultationType}
                    productType={orderItem.productSlug}
                    subcategory={orderItem.subcategory}
                    imgStyle={{
                      height: "80px",
                      width: "80px",
                      objectFit: "scale-down",
                    }}
                  />
                </div>
                <div style={{ marginLeft: "20px", fontSize: "16px" }}>
                  {productName(orderItem.productSlug, orderItem.subcategory)}
                </div>
              </div>
            </div>
          ))}
        </div>

        <Button
          color="primary"
          size="large"
          style={{
            backgroundColor: kickBlue,
            color: "white",
            margin: "60px 0",
            width: "300px",
          }}
          onClick={() => {
            window.location.href = `/visits/${consultationType}/payment/order-details`;
          }}
        >
          Continue <NavigateNextIcon />
        </Button>
      </div>
    </main>
  );
}
